import b from 'b_';
import { ProgressLine, Text } from 'platform-components';
import { TEXT_MARKUP_TYPE } from 'platform-components/constants';
import React from 'react';
import { connect } from 'react-redux';

import * as lessonViewSelectors from 'common.components/lesson-view.store/selectors';
import { getLessonResultShowTimeColumnStats } from 'common.components/lesson/selectors';
import { getTeamIdFromPath } from 'utils/path';

import { EmptyStateContainer } from '../__empty-state/stats__empty-state.container';
// @ts-ignore
import COLORS from '../constants.scss';
import * as selectors from '../selectors';

interface StoreProps {
    assignedStudents: number;
    performancePercent: number;
    shouldShowEmptyState: boolean;
    startedStudents: number;
    time: string;
    shouldShowPerformance: boolean;
    shouldShowLessonTime: boolean;
}

interface Props extends StoreProps {}

export const LessonStats = (props: Props) => {
    const {
        assignedStudents,
        performancePercent,
        shouldShowEmptyState,
        startedStudents,
        time,
        shouldShowPerformance,
        shouldShowLessonTime,
    } = props;

    if (shouldShowEmptyState) {
        return <EmptyStateContainer />;
    }

    return (
        <>
            <div className={b('stats', 'item', { type: 'students-started' })}>
                <span>
                    <Text size={Text.SIZE.XXL}>{startedStudents}/</Text>
                    <Text size={Text.SIZE.XL}>{assignedStudents}</Text>
                </span>
                <ProgressLine
                    mix="stats__progress-line"
                    success={startedStudents}
                    unknown={assignedStudents - startedStudents}
                />
                <Text
                    color={COLORS.lessonStatText}
                    id="lessonView.stats.studentsStarted"
                    type={TEXT_MARKUP_TYPE.MARKDOWN}
                />
            </div>
            {shouldShowPerformance && (
                <div className={b('stats', 'item', { type: 'performance' })}>
                    <Text
                        id="lessonView.stats.studentPerformancePercent"
                        size={Text.SIZE.XXL}
                        values={{ percent: performancePercent }}
                    />
                    <ProgressLine
                        mix="stats__progress-line"
                        success={performancePercent}
                        unknown={100 - performancePercent}
                    />
                    <Text
                        color={COLORS.lessonStatText}
                        id="lessonView.stats.studentPerformance"
                        type={TEXT_MARKUP_TYPE.MARKDOWN}
                    />
                </div>
            )}
            {shouldShowLessonTime && (
                <div className={b('stats', 'item', { type: 'time' })}>
                    <Text size={Text.SIZE.XXL}>{time}</Text>
                    <Text
                        color={COLORS.lessonStatText}
                        id="lessonView.stats.lessonTime"
                        type={TEXT_MARKUP_TYPE.MARKDOWN}
                    />
                </div>
            )}
        </>
    );
};

const mapStateToProps = (storeState: any): StoreProps => {
    const classId = getTeamIdFromPath();

    return {
        performancePercent: selectors.getPerformancePercent(storeState, { classId }),
        shouldShowEmptyState: selectors.getAreLessonStatsEmpty(storeState, { classId }),
        startedStudents: selectors.getStartedStudents(storeState, { classId }).length,
        time: selectors.getAverageLessonTime(storeState, { classId }),
        assignedStudents: selectors.getAssignedStudents(storeState, { classId }).length,
        shouldShowPerformance: !lessonViewSelectors.getHasAnyDictationProblem(storeState),
        shouldShowLessonTime: getLessonResultShowTimeColumnStats(storeState),
    };
};

export default connect(mapStateToProps)(LessonStats);
